import { useTheme } from 'foundations-theming-specialty/utils';
import { isTrellisTheme } from 'foundations-theming/utils';
import { SVGIconBase } from './SVGIconBase';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UpgradeArrow = () => {
  const theme = useTheme();
  if (isTrellisTheme(theme)) {
    return /*#__PURE__*/_jsxs(SVGIconBase, {
      "data-test-id": "hs-upgrade-arrow",
      viewBox: "0 0 32 32",
      width: "16px",
      height: "16px",
      children: [/*#__PURE__*/_jsx("path", {
        fill: theme.color['global-shell-icon-nav-item-default'],
        d: "M16 23.85c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v13.85c0 .55-.45 1-1 1"
      }), /*#__PURE__*/_jsx("path", {
        fill: theme.color['global-shell-icon-nav-item-default'],
        d: "M21.33 15.33c-.26 0-.51-.1-.71-.29L16 10.42l-4.62 4.62a.996.996 0 1 1-1.41-1.41L15.3 8.3c.38-.38 1.04-.38 1.41 0l5.33 5.33a.996.996 0 0 1-.71 1.7"
      }), /*#__PURE__*/_jsx("path", {
        fill: theme.color['global-shell-icon-nav-item-default'],
        d: "M16 30C8.28 30 2 23.72 2 16S8.28 2 16 2s14 6.28 14 14-6.28 14-14 14m0-26C9.38 4 4 9.38 4 16s5.38 12 12 12 12-5.38 12-12S22.62 4 16 4"
      })]
    });
  }
  return /*#__PURE__*/_jsxs("svg", {
    "data-test-id": "hs-upgrade-arrow",
    viewBox: "0 0 12.83 12.83",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "14px",
    children: [/*#__PURE__*/_jsx("mask", {
      id: "upgradeArrow",
      height: "12.83",
      maskUnits: "userSpaceOnUse",
      width: "12.83",
      x: "0",
      y: "0",
      children: /*#__PURE__*/_jsx("path", {
        d: "m0 0h12.83v12.83h-12.83z",
        fill: theme.color['icon-core-on-fill-default'],
        fillRule: "evenodd"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#upgradeArrow)",
      children: /*#__PURE__*/_jsx("path", {
        d: "m6.42 0a6.42 6.42 0 1 0 6.41 6.42 6.41 6.41 0 0 0 -6.41-6.42",
        fill: theme.color['fill-primary-pressed'],
        fillRule: "evenodd"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#upgradeArrow)",
      children: /*#__PURE__*/_jsx("path", {
        d: "m10 6.08a.6.6 0 0 1 -1 0l-2-2v6.29c0 .49-.13.69-.68.69s-.69-.12-.69-.69v-6.26l-2 2a.61.61 0 0 1 -1 0 .57.57 0 0 1 0-1l3.22-3.11a.68.68 0 0 1 1 0l3.15 3.11a.59.59 0 0 1 0 1",
        fill: "#fff",
        fillRule: "evenodd"
      })
    })]
  });
};